import React from 'react';
import PropTypes from 'prop-types';

import { pure } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from 'react-native';
import CalendarModal from '../../../components/common/calendar-modal';
import GenericDateSelectionBar from '../../../components/common/date-selection-bar';
import datesAreEqual from 'date-fns/is_equal';
import format from 'date-fns/format';
import styles from './date-selection-bar.styles';
import { Small} from '../../../components/common/text';
import SimpleDate from '../../../components/common/date';
var languageCode = 'en';

function currentDateText(fromDate, toDate,messages) {

  if (datesAreEqual(fromDate, toDate)) {
    return (
      <Small> {messages['app.common.show']} <SimpleDate value={fromDate}/> </Small>
    );
  }
  return (
  <Small> {messages['app.common.show']} {<SimpleDate value={fromDate}/>} {messages['app.common.to']} {<SimpleDate value={toDate}/>} </Small>
  );
}

function DateSelectionBar({
  advices: {
    calendar,
    fromDate,
    toDate,
    isDateBarClickable,
  },
  messages,
  ...props
}) {

  const { auth: { langCode }} = props;
  if (props.auth.langCode && props.auth.langCode != null) {
    languageCode = props.auth.langCode.toLowerCase();
  }

  return (
    <View testID="date-selection-bar" style={styles.root}>
      <CalendarModal
        numberOfPastMonth={24}
        calendarModal={calendar}
        messages={messages}
        scrollOnce={true}
        languageCode={languageCode}
      />
      <GenericDateSelectionBar
        text={currentDateText(fromDate, toDate,messages)}
        isEditable={isDateBarClickable}
        onEditPress={() => calendar.open()}
      />
    </View>
  );
}

DateSelectionBar.propTypes = {
  advices: PropTypes.shape({
    calendar: PropTypes.object.isRequired,
    fromDate: PropTypes.string,
    toDate: PropTypes.string,
    isDateBarClickable: PropTypes.bool,
  }),
};

export default createContainer({
  $queries: {
    auth: {
      langCode: true,
    },
  },
  $fragments: {
    advices: {
      calendar: {
        open: { $call: 'open' },
        ...CalendarModal.getFragment('calendarModal'),
      },
      fromDate: true,
      toDate: true,
      isDateBarClickable: true,
    },
  },
})(pure(DateSelectionBar));
export { DateSelectionBar };
